import { render, staticRenderFns } from "./userTriggerRules.vue?vue&type=template&id=273b9a4e&"
import script from "./userTriggerRules.vue?vue&type=script&lang=js&"
export * from "./userTriggerRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports